import { render, staticRenderFns } from "./ViewClientBuildings.vue?vue&type=template&id=5e15b0dd"
import script from "./ViewClientBuildings.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewClientBuildings.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports